export const TextareaIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 87C53 83.6863 55.6863 81 59 81H341C344.314 81 347 83.6863 347 87V213C347 216.314 344.314 219 341 219H59C55.6863 219 53 216.314 53 213V87Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70 105.5C70 103.015 72.0147 101 74.5 101H195.5C197.985 101 200 103.015 200 105.5C200 107.985 197.985 110 195.5 110H74.5C72.0147 110 70 107.985 70 105.5Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70 128.5C70 126.015 72.0147 124 74.5 124H245.5C247.985 124 250 126.015 250 128.5C250 130.985 247.985 133 245.5 133H74.5C72.0147 133 70 130.985 70 128.5Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70 151.5C70 149.015 72.0147 147 74.5 147H315.5C317.985 147 320 149.015 320 151.5C320 153.985 317.985 156 315.5 156H74.5C72.0147 156 70 153.985 70 151.5Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70 174.5C70 172.015 72.0147 170 74.5 170H285.5C287.985 170 290 172.015 290 174.5C290 176.985 287.985 179 285.5 179H74.5C72.0147 179 70 176.985 70 174.5Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M332.44 226.091C331.546 226.091 331.101 227.176 331.739 227.804L335.298 231.309C335.687 231.692 336.312 231.692 336.702 231.309L340.261 227.804C340.898 227.176 340.454 226.091 339.559 226.091H337.2V211.909H339.559C340.454 211.909 340.898 210.824 340.261 210.197L336.702 206.691C336.312 206.308 335.687 206.308 335.298 206.691L331.739 210.197C331.101 210.824 331.546 211.909 332.44 211.909H334.8V226.091H332.44Z'
      fill='#4A5568'
    />
  </svg>
)
